/* global Waypoint */

class StickyTop {
  constructor () {
    if ( this.detectStickySupport() ) {
      return;
    }

    this.fetchWaypoints( this.startWaypoints.bind(this) );
  }

  startWaypoints () {
    const headerEl = document.querySelector('.c-header');
    const wrapperEl = document.querySelector('.o-sticky-top');
    const contentEl = document.querySelector('.o-sticky-top__content');
    const spacerEl = document.querySelector('.o-sticky-top__spacer');

    this.cloneHeight(contentEl, wrapperEl);
    window.addEventListener('resize', () => this.cloneHeight(contentEl, wrapperEl), false);
    contentEl.insertAdjacentElement('beforebegin', spacerEl);
    contentEl.classList.add('is-fixed');

    new Waypoint({
      element: spacerEl,
      handler () {
        contentEl.classList.toggle('is-fixed');
      },
      offset () {
        return -spacerEl.clientHeight + headerEl.clientHeight;
      }
    });
  }

  cloneHeight (aEl, bEl) {
    bEl.style.minHeight = `${aEl.clientHeight}px`;
  }

  fetchWaypoints (callback) {
    const URL = `https://cdnjs.cloudflare.com/ajax/libs/waypoints/4.0.1/noframework.waypoints.min.js`;
    const scriptEl = document.createElement('script');

    scriptEl.setAttribute('src', URL);
    document.head.appendChild(scriptEl);
    scriptEl.addEventListener('load', callback);
  }

  detectStickySupport () {
    if (!window.CSS) {
      return false;
    }

    if (
      CSS.supports &&
      CSS.supports('(position: sticky)') ||
      CSS.supports('(position: -webkit-sticky)')
    ) {
      return true;
    }

    return false;
  }
}

export default StickyTop;
